import DOMPurify from 'dompurify';
import { TemplateClasico }     from './TemplateClasico';
import { TemplateMinimalista } from './TemplateMinimalista';
import { TemplateCorporativo } from './TemplateCorporativo';
import { TemplateBarra }       from './TemplateBarra';
import { renderPersonalizadaHtml } from './renderPersonalizada';
import type { TemplateData, DisenoPlantilla } from './template-types';

export function TemplateRenderer({ data, diseno, width, height, disenoPersonalizadoHtml }: {
  data: TemplateData;
  diseno: DisenoPlantilla;
  width: number;
  height: number;
  disenoPersonalizadoHtml?: string | null;
}) {
  switch (diseno) {
    case 'clasico':     return <TemplateClasico     data={data} width={width} height={height} />;
    case 'minimalista': return <TemplateMinimalista data={data} width={width} height={height} />;
    case 'corporativo': return <TemplateCorporativo data={data} width={width} height={height} />;
    case 'barra':       return <TemplateBarra       data={data} width={width} height={height} />;
    case 'personalizada': {
      if (!disenoPersonalizadoHtml) {
        return (
          <div style={{ width, height, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb', color: '#9ca3af', fontFamily: 'Arial, sans-serif', fontSize: 13, textAlign: 'center', padding: 24, boxSizing: 'border-box' }}>
            Configura el diseño personalizado en el editor visual
          </div>
        );
      }
      const html = DOMPurify.sanitize(renderPersonalizadaHtml(disenoPersonalizadoHtml, data));
      return (
        <div style={{ width, height, overflow: 'hidden', background: '#fff' }} dangerouslySetInnerHTML={{ __html: html }} />
      );
    }
  }
}
